import { ComponentProps, forwardRef } from 'react';

import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

import { DialogComposite } from '../DialogComposite';
import { useDialogContext } from '../DialogComposite/context';
import Cancel from './Cancel';
import Next from './Next';
import Prev from './Prev';
import Submit from './Submit';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      paddingRight: 0,
      flexShrink: 0,
      paddingBottom: 0,
      marginTop: theme.spacing(4),
    },
    rootFullScreen: {
      marginTop: 'auto',
      paddingBottom: theme.spacing(3),
    },
  });

export type ActionsProps = WithStyles<typeof styles> &
  ComponentProps<typeof DialogComposite.Actions> & {
    disabled?: boolean;
    fullScreen?: boolean;
  };

const Actions = forwardRef<HTMLDivElement, ActionsProps>((props, ref) => {
  const { classes, className, disabled, children, ...rest } = props;
  const { props: dialogProps } = useDialogContext();
  const isFullScreen = Boolean(dialogProps?.fullScreen) as boolean;

  return (
    <DialogComposite.Actions
      ref={ref}
      className={classNames(classes.root, className, {
        [classes.rootFullScreen]: isFullScreen,
      })}
      {...rest}
    >
      {children}
    </DialogComposite.Actions>
  );
});

Actions.displayName = 'MultiStepDialog.Actions';

const StyledActions = withStyles(styles)(Actions);

StyledActions.displayName = 'MultiStepDialog.Actions';

export default Object.assign(StyledActions, {
  Next,
  Prev,
  Submit,
  Cancel,
});
